import React, { ReactNode } from "react";
import { useAccounts } from "../../hooks/useAccounts/useAccounts";
import { AccountContext } from "../../contexts/AccountsContext/AccountsContext";

interface AccountsProviderProps {
  children: ReactNode;
}

export const AccountsProvider = ({ children }: AccountsProviderProps) => {
  const accountsContextData = useAccounts();
  return (
    <AccountContext.Provider value={accountsContextData}>
      {children}
    </AccountContext.Provider>
  );
};
